<template>
  <md-card>
    <md-card-content>
      <div class="md-layout" style="height: 200px;">
        <div class="md-layout-item md-size-100">
          <h4 class="caed-title">Datos del Flete</h4>
        </div>

        <form class="md-layout-item" id="freight_form" @submit.prevent="saveFreight()">
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-35">
              <multiselect
                data-vv-name="orders"
                v-model="updatedFreight.orders"
                v-validate="modelValidations.orders"
                tag-placeholder="Add"
                placeholder="Agregar Orden de Compra"
                label="folio"
                track-by="id"
                :disabled="updating"
                :options="list_orders"
                :multiple="true"
                :taggable="true"
                :max-height="150"
              ></multiselect>
            </div>
            <div class="md-layout-item md-medium-size-35">
              <multiselect
                data-vv-name="provider"
                v-model="updatedFreight.provider"
                v-validate="modelValidations.provider"
                tag-placeholder="Add"
                placeholder="Seleccionar proveedor"
                :custom-label="customLabel"
                track-by="id"
                :disabled="updating"
                :options="fetchedProviders"
                :multiple="false"
                :taggable="true"
                :max-height="150"
              ></multiselect>
            </div>
            <div class="md-layout-item md-size-15">
              <md-field :class="validationClass('amount')">
                <label>Subtotal</label>
                <md-input
                  type="decimal"
                  data-vv-name="amount"
                  v-validate="modelValidations.amount"
                  v-model="fetchSubtotal"
                  :disabled="true"
                ></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-15">
              <md-field :class="validationClass('total')">
                <label>Total</label>
                <md-input
                  type="decimal"
                  data-vv-name="total"
                  v-validate="modelValidations.total"
                  v-model="fetchTotal"
                  :disabled="true"
                ></md-input>
              </md-field>
            </div>
          </div>
          <!-- <div class="md-layout">
            <div class="md-layout-item md-size-50 md-small-size-100">
              <md-field :class="validationClass('invoice_number')">
                <label> Número de Factura </label>
                <md-input
                  type="text"
                  data-vv-name="invoice_number"
                  v-validate="modelValidations.invoice_number"
                  v-model="updatedFreight.invoice_number"
                >
                </md-input>
              </md-field>
            </div>
          </div>-->
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-50">
              <md-button
                class="md-fileinput md-round md-layout-item md-size-100 md-size-small-30 ml-auto"
                :class="{ ['md-success']: !!updatedFreight.invoice_pdf }"
              >
                <md-icon>{{ !updatedFreight.invoice_pdf ? "add" : "check" }}</md-icon>
                <label style="margin: 5px;">
                  {{
                  !updatedFreight.invoice_pdf
                  ? "Seleccionar Factura (PDF) *"
                  : `PDF cargado ${getFileName(updatedFreight.invoice_pdf)}`
                  }}
                </label>
                <input
                  type="file"
                  data-vv-name="invoice_pdf"
                  accept=".pdf"
                  v-validate="modelValidations.invoice_pdf"
                  @change="onFileChange($event, 'pdf')"
                />
              </md-button>
            </div>
            <div class="md-layout-item md-size-50">
              <md-button
                class="md-fileinput md-round md-layout-item md-size-100 md-size-small-30 ml-auto"
                :class="{ ['md-success']: !!updatedFreight.invoice_xml }"
              >
                <md-icon>{{ !updatedFreight.invoice_xml ? "add" : "check" }}</md-icon>
                <label style="margin: 5px;">
                  {{
                  !updatedFreight.invoice_xml
                  ? "Seleccionar Factura (XML) *"
                  : `XML cargado ${getFileName(updatedFreight.invoice_xml)}`
                  }}
                </label>
                <input
                  type="file"
                  data-vv-name="invoice_xml"
                  accept=".xml"
                  v-validate="modelValidations.invoice_xml"
                  @change="onFileChange($event, 'xml')"
                />
              </md-button>
            </div>
            <p
              class="error-note"
              v-if="differentNameFiles"
            >Los archivos PDF y XML no se llaman igual. No es posible calcular el subtotal</p>
          </div>
          <p
            v-if="validatorMessage"
            style="color: red;"
          >Revise que se llenaron todos los campos y se subieron los archivos de la factura.</p>
          <md-card class="supplies-table-container" v-if="showTable">
            <md-card-header class="md-card-header-icon md-card-header-green">
              <div class="md-layout">
                <h4 class="md-layout-item md-size-40 title">Insumos</h4>
                <div class="md-size-25 ml-auto">
                  <slot name="header"></slot>
                </div>
              </div>
            </md-card-header>
            <md-card-content>
              <md-table v-model="newDatas">
                <md-table-row slot="md-table-row" slot-scope="{ item }">
                  <md-table-cell md-label="Clave" md-sort-by="id" md-numeric>
                    {{
                    item.code
                    }}
                  </md-table-cell>
                  <md-table-cell md-label="Insumo" md-sort-by="name">
                    {{
                    item.supplyName
                    }}
                  </md-table-cell>
                  <md-table-cell md-label="Cantidad" md-sort-by="email">
                    {{
                    item.quantity
                    }}
                  </md-table-cell>
                  <md-table-cell md-label="Precio Unitario" md-sort-by="gender">
                    {{
                    Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    }).format(item.unitPrice)
                    }}
                  </md-table-cell>
                  <md-table-cell md-label="Sub-Total" md-sort-by="title">
                    {{
                    Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    }).format(item.subTotal)
                    }}
                  </md-table-cell>
                  <md-table-cell md-label="Flete Unitario" md-sort-by="email">
                    {{
                    Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    }).format(item.freight)
                    }}
                  </md-table-cell>
                  <md-table-cell md-label="Sub-Total Flete" md-sort-by="gender">
                    {{
                    Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    }).format(item.subFreight)
                    }}
                  </md-table-cell>
                  <md-table-cell md-label="Total" md-sort-by="title">
                    {{
                    Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    }).format(item.total)
                    }}
                  </md-table-cell>
                </md-table-row>
              </md-table>
            </md-card-content>
          </md-card>
        </form>
      </div>
    </md-card-content>
    <md-card-actions>
      <md-button
        type="submit"
        @click="getSubtotal"
        class="md-warning"
        :disabled="!updatedFreight.invoice_xml || !updatedFreight.invoice_pdf || differentNameFiles || loadingSubtotal"
      >Obtener Subtotal</md-button>
      <md-button
        type="submit"
        form="freight_form"
        class="md-success"
        :disabled="loadingSubtotal"
      >Crear Flete</md-button>
    </md-card-actions>
  </md-card>
</template>

<script>
import purchaseService from "@/services/purchase";

const freightHeaders = {
  folio: "Clave",
  supply: "Insumo",
  quantity: "Cantidad",
  amount: "P.U.",
  subtotal: "Sub-total",
  freight: "Flete Unitario",
  subFreight: "Flete",
  total: "Total",
};

const modelValidations = {
  provider: {
    required: true,
  },
  amount: {
    required: true,
  },
  total: {
    required: true,
  },
  orders: {
    required: true,
  },
  invoice_xml: {
    required: true,
  },
  invoice_pdf: {
    required: true,
  },
};

export default {
  name: "EditFreight",
  props: {
    freight: Object,
    title: {
      type: String,
      default: "Editar Flete",
    },
    updating: Boolean,
    orders: Array,
    // fetchedWarehouses: {
    //   type: Array,
    // },
    fetchedProviders: {
      type: Array,
    },
  },
  data() {
    return {
      newDatas: [],
      providers: [],
      // camps: [],
      loadingSubtotal: false,
      list_orders: [],
      total: 0,
      showTable: false,
      freightFilters: {},
      validatorMessage: false,
      updatedFreight: {
        orders: [],
        invoice_pdf: null,
        invoice_xml: null,
        provider: null,
      },
      fetchSubtotal: null,
      fetchTotal: null,
      freightHeaders,
      freightSearchableProps: Object.keys(freightHeaders),

      modelValidations,
      touched: {
        name: false,
        codename: false,
      },
    };
  },
  computed: {
    fetchedSubtotal() {
      return 0;
    },
    canRequestFreight() {
      return (
        this.updatedFreight.invoice_pdf &&
        this.updatedFreight.invoice_xml &&
        this.updatedFreight.amount
      );
    },
    differentNameFiles() {
      const { invoice_pdf, invoice_xml } = this.updatedFreight;
      const xmlName = invoice_xml ? invoice_xml.name.split(".").shift() : "";
      const pdfName = invoice_pdf ? invoice_pdf.name.split(".").shift() : "";
      return xmlName && pdfName && xmlName !== pdfName;
    },
  },
  methods: {
    customLabel({ providerNumber, commercialName }) {
      return `${providerNumber} – ${commercialName}`;
    },
    getSubtotal() {
      this.loadingSubtotal = true;
      purchaseService
        .fetchFreightSubtotal(this.updatedFreight)
        .then(({ subtotal, total }) => {
          this.fetchTotal = total;
          this.fetchSubtotal = subtotal;
        })
        .catch((err) => {
          this.$fireErrorResponse(err);
          this.paginationInfo = null;
          this.freightData = [];
        })
        .finally(() => (this.loadingSubtotal = false));
    },
    saveFreight() {
      const { almacen: iwarehouseId } = this.$route.query;
      const payload = {
        original: this.freight,
        updated: {
          ...this.updatedFreight,
          amount: this.fetchTotal,
          subtotal: this.fetchSubtotal,
          warehouseId: iwarehouseId,
        },
      };
      this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          this.validatorMessage = false;
          this.$emit("saved", payload);
        } else {
          this.validatorMessage = true;
        }
      });
    },
    onFileChange(e, type) {
      e.stopPropagation();
      let files = e.target.files || e.dataTransfer.files;
      const file = files[0];
      if (type == "pdf") this.updatedFreight.invoice_pdf = file;
      else if (type == "xml") this.updatedFreight.invoice_xml = file;
    },
    updateSuppliesTable() {
      this.showTable = false;
      if (this.updatedFreight.orders) {
        if (this.updatedFreight.orders.length != 0) {
          if (this.updatedFreight.amount) {
            this.showTable = true;
            this.newDatas = [];
            this.list_orders.forEach((order) => {
              if (this.updatedFreight.orders.includes(order))
                order.consolidatedSupplies.forEach((supply) => {
                  this.newDatas.push(supply);
                });
            });
            let total_amount = 0;
            for (let i = 0; i < this.newDatas.length; i++) {
              total_amount = total_amount + this.newDatas[i]["subTotal"];
            }
            let percentage_freight = this.updatedFreight.amount / total_amount;
            let total = 0;
            for (let i = 0; i < this.newDatas.length; i++) {
              let _freight = percentage_freight * this.newDatas[i]["subTotal"];
              let _total = this.newDatas[i]["subTotal"] + _freight;
              this.newDatas[i]["freight"] = (
                _freight / this.newDatas[i]["quantity"]
              ).toFixed(3);
              this.newDatas[i]["subFreight"] = _freight.toFixed(3);
              this.newDatas[i]["total"] = _total.toFixed(3);
              total = total + _total;
            }
            this.total = total.toFixed(2);
          }
        }
      }
    },
    getFileName({ name }) {
      return name;
    },
  },
  created() {
    if (this.freight.id) {
      this.updatedFreight = this.cloneDeep(this.freight);
    }
  },
  mounted() {
    this.watchTouched({ updatedFreight: Object.keys(modelValidations) });
    this.list_orders = this.orders;
    if (this.updating) {
      this.updatedFreight.invoice_xml = null;
      this.updatedFreight.invoice_pdf = null;
    }
  },
  watch: {
    "updatedFreight.amount": function () {
      this.updateSuppliesTable();
    },
    "updatedFreight.orders": function () {
      this.updateSuppliesTable();
    },
  },
};
</script>

<!-- <style scoped lang="css" src="vue-multiselect/dist/vue-multiselect.min.css">
.md-card,
.md-card-content,
.md-card-actions {
  border: none !important;
  margin: 0 !important;
  box-shadow: none !important;
}
</style> -->
<style scoped lang="css">
.md-card,
.md-card-content,
.md-card-actions {
  border: none !important;
  margin: 0 !important;
  box-shadow: none !important;
}

.supplies-table-container {
  margin: 0 12px;
}

.error-note {
  color: red;
  font-weight: 800;
  font-size: 18px;
  margin-top: 12px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Purchases/Freight/Edit.vue